import gql from 'graphql-tag';
import ImageDataFragment from './ImageData.gql';

export default gql`
  fragment ImageItemFragment on ImageItem {
    id
    type
    data {
      ...ImageDataFragment
    }
  }
  ${ImageDataFragment}
`;
